import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { FaQrcode } from "react-icons/fa";
import { getFormsWebBaseUrl } from "../../helpers/formsAutofill";

// Fallback shown when a Parent app handoff link (<parent-host>/open/<code>) was
// NOT intercepted by the app — i.e. it isn't installed. The primary action
// returns to the public form on the forms web app; a store link is offered on
// Android only (this page can't reliably build an App Store link) and never
// auto-redirects.
const PARENT_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.mykoku.parent";

const isAndroid = () => /android/i.test(navigator.userAgent);

const OpenInApp = () => {
  const { t } = useTranslation();
  const { code } = useParams();
  const base = getFormsWebBaseUrl();
  const formUrl =
    code && base ? `${base}/f/${encodeURIComponent(code)}` : base || "/";

  return (
    <div className="min-h-screen grid place-items-center px-6 text-center">
      <div className="w-full max-w-sm">
        <div className="w-16 h-16 mx-auto mb-5 grid place-items-center rounded-2xl bg-gray-100">
          <FaQrcode className="w-8 h-8 text-gray-600" />
        </div>
        <h1 className="text-xl font-semibold mb-2">{t("openInApp.title")}</h1>
        <p className="text-gray-500 mb-6">{t("openInApp.subtitle")}</p>
        <a
          href={formUrl}
          className="block w-full rounded-xl bg-theme text-white py-3 font-medium mb-3"
        >
          {t("openInApp.continueInBrowser")}
        </a>
        {isAndroid() && (
          <a
            href={PARENT_PLAY_STORE_URL}
            className="block w-full rounded-xl border-2 py-3 font-medium"
          >
            {t("openInApp.getApp")}
          </a>
        )}
      </div>
    </div>
  );
};

export default OpenInApp;
